<template>
   <div :class="['navigation primary-navigation-container d-flex', { 'mt-5': bannerAvailable }]">
      <div class="navigation__logo">
         <a href="/" @click.prevent="$router.push('/')">
            <img
               src="../../../public/images/fusionChartsLogo_idera.svg"
               alt="FusionCharts"
               class="logo__fc"
            />
         </a>
      </div>
      <mq-layout mq="lg+">
         <ul class="navigation__items">
            <li class="navigation__items-item">
               <!-- Contact Sales -->
               <button
                  class="btn btn-outline-primary navbar-btn"
                  @click="modalShowContactSales = !modalShowContactSales"
               >
                  Contact Sales
               </button>

               <!-- Contact Support -->
               <button
                  class="btn btn-primary navbar-btn"
                  @click="modalShowContactSupport = !modalShowContactSupport"
               >
                  Contact Support
               </button>
            </li>
         </ul>
      </mq-layout>

      <!--Mobile Menu-->
      <mq-layout :mq="['xs', 'sm', 'md', 'navigation']">
         <div class="mobile-menu">
            <i
               class="mobile-menu__menu-icon fc_menu"
               :class="{ check: showMenu }"
               @click="menuToggle"
            ></i>
            <i
               class="mobile-menu__menu-icon fc_close"
               :class="{ check: !showMenu }"
               @click="menuToggle"
            ></i>
            <div class="mobile-menu__menu" :class="{ active: showMenu }">
               <button class="btn btn-link" @click="modalShowContactSales = !modalShowContactSales">
                  Contact Sales
               </button>

               <button
                  class="btn btn-link"
                  @click="modalShowContactSupport = !modalShowContactSupport"
               >
                  Contact Support
               </button>
            </div>
         </div>
      </mq-layout>
      <!--Contact Sales-->
      <b-modal v-model="modalShowContactSales" centered hide-footer>
         <ContactSales :purpose-options="purpose_options" />
      </b-modal>

      <!--Contact Support-->
      <b-modal v-model="modalShowContactSupport" centered hide-footer>
         <ContactSupport :purpose-options="purpose_options" />
      </b-modal>
   </div>
</template>

<script>
import { mapState } from 'vuex';
import ContactSales from '../../components/elforms/Sales';
import ContactSupport from '../../components/forms/Support';

export default {
   name: 'PrimaryNavSpecial',
   components: {
      ContactSales,
      ContactSupport,
   },

   computed: {
      ...mapState(['bannerAvailable']),
   },
   data() {
      return {
         showMenu: false,
         modalShowContactSales: false,
         modalShowContactSupport: false,
         purpose_options: [
            {
               value: 'saas-quote',
               text: 'Licensing query for a SaaS application',
            },
            {
               value: 'oem-quote',
               text: 'Licensing query for an on-premise application (OEM)',
            },
            {
               text: 'Licensing query for an enterprise plan',
               value: 'licensing-query-for-an-enterprise-plan',
            },
            {
               text: 'Reseller enquiry',
               value: 'reseller-enquiry',
            },
            {
               value: 'licensing-fusionexport',
               text: 'Licensing FusionExport',
            },
            { value: 'offline-payment', text: 'Payment through PO/Wire/Check' },
            { value: 'product-technical-query', text: '​Product/Technical related query' },
            { value: 'other', text: 'Other' },
         ],
      };
   },
   methods: {
      menuToggle() {
         this.showMenu = !this.showMenu;
      },
   },
};
</script>

<style lang="scss" scoped>
.primary-navigation-container {
   position: fixed;
   left: 0;
   top: 0;
   z-index: 1000;

   background-color: #ffffff;
   height: 54px;
   width: 100%;
   padding: 0 3%;
   // overflow: hidden;
   box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.04);
   @media (max-width: 1079px) {
      padding: 0 15px;
   }
   .mobile-menu {
      height: 100%;
      position: relative;
      transition: all 0.35s ease;
      &__menu-icon {
         color: rgba(49, 49, 49, 0.6);
         position: absolute;
         top: 50%;
         right: 0;
         transform: translateY(-50%);
         transition: all 0.35s ease;
         opacity: 1;
         visibility: visible;
         cursor: pointer;
      }
      .mobile-menu__menu {
         position: fixed;
         background-color: #ffffff;
         width: 100%;
         height: 100%;
         top: 57px;
         left: 0;
         z-index: -1;
         transform: translateX(100%);
         transition: all 0.35s ease;
         opacity: 0;
         visibility: hidden;
         @media (max-width: 1079px) {
            top: 54px;
         }
      }
   }
}
.navigation__logo {
   //overflow: hidden;
   display: flex;
   align-items: center;
   width: 200px;
   flex-shrink: 0;
   .logo__fc {
      max-width: 100%;
      height: 27px;
      cursor: pointer;
   }
}
.navigation__items {
   display: flex;
   align-items: center;
   justify-content: flex-end;

   width: 100%;
   height: 100%;
   margin: 0;
   padding: 0;
   &-item {
      list-style-type: none;
   }
   .navbar-btn {
      font-size: 14px;
      line-height: 14px;
      margin-left: 20px;
      padding: 10px 16px;
   }
   .navbar-btn--download {
      padding: 11px 16px;
   }
}
.navigation > div:last-child {
   width: 100%;
}
.active {
   visibility: visible !important;
   transform: translateX(0) !important;
   opacity: 1 !important;
}
.stcky-nav {
   position: fixed;
   bottom: 0;
   width: 100%;
   left: 0;
   background-color: teal;
   display: flex;
   height: 200px;
}
.check {
   visibility: hidden !important;
   opacity: 0 !important;
}

.btn-link {
   display: block;
}
</style>
